const units = ['Bytes', 'KB', 'MB', 'GB']

export function bytesToUnitString(value: unknown) {
  const bytes = Number(value)

  if (!bytes) return 'n/a'

  const scale = Math.floor(Math.log(bytes) / Math.log(1024))

  return `${(bytes / Math.pow(1024, scale)).toFixed(1)} ${units[scale]}`
}
